import {Loadable} from 'app/components/general/lazyLoader';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';

import type {SweetError} from 'app/utils/errors';

export const LoadableAccountOverviewPage = Loadable<SweetError, unknown>({
  loader: () =>
    import(
      /* webpackChunkName: "account-overview" */
      './AccountOverviewPage'
    ),
  LoadingComponent: DetailLoadingPage,
});
